import DialogComponent from '../../widgets/dialog/DialogComponent';
import { SubmitButton } from '../../widgets';

export default class CreateGroupDialog extends DialogComponent {

  nameInput: HTMLElement = null;

  state = {
    name: '',
    description: '',
    nameError: false
  }

  onNameChanged = (event: any) => {
    this.setState({ name: event.target.value, nameError: false });
  }

  onDescriptionChanged = (event: any) => {
    this.setState({ description: event.target.value });
  }

  onSubmitClicked = () => {
    const { name, description } = this.state;
    if (name.trim() === '') {
      return this.setState({ nameError: true });
    }
    this.resolve({ name, description });
    this.close();
  }

  render() {
    const { name, description, nameError } = this.state;
    const nameClass = 'dialog-input lg-input' + (nameError ? ' input-error' : '');
    return (
      <div className="row">
        <div className="col-6">
          <div className="form-group">
            <input
              type="text"
              ref={input => this.nameInput = input}
              value={name}
              className={nameClass}
              onChange={this.onNameChanged}
              placeholder="نام گروه" />
          </div>
        </div>
        <div className="col-12">
          <div className="form-group">
            <textarea
              placeholder="توضیحات (اختیاری)"
              className="dialog-input lg-input no-resize"
              onChange={this.onDescriptionChanged}
              value={description}
            ></textarea>
          </div>
          <div className="form-group text-center">
            <SubmitButton text="ایجاد گروه" style={{ width: '200px' }} onClick={this.onSubmitClicked} />
          </div>
        </div>
      </div>
    );
  }

  componentDidMount() {
    this.nameInput.focus();
  }

}
